/*!

=========================================================
* Vue Argon Design System - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system/blob/master/LICENSE.md)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import './registerServiceWorker'
import BootstrapVue from 'bootstrap-vue'
import { BootstrapVueIcons } from 'bootstrap-vue'
import store from "./store";
import VueCurrencyFilter from 'vue-currency-filter'
import i18n from '@/lang'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/ru";
import axios from 'axios'
// import { vsSlider } from 'vuesax'
// import 'vuesax/dist/vuesax.css';
// Vue.use(vsSlider)
import '@vueform/slider/themes/default.css'
import VueCompositionAPI from '@vue/composition-api'
axios.defaults.baseURL = "https://uzasbo.mdm.uz/";
Vue.use(VueCompositionAPI)
Vue.component("date-picker", DatePicker);
Vue.component('v-select', vSelect)
Vue.config.productionTip = false;
Vue.use(Argon);
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueCurrencyFilter, {
	symbol: 'c',
	thousandsSeparator: ' ',
	fractionCount: 0,
	fractionSeparator: ',',
	symbolPosition: 'back',
	symbolSpacing: true
});
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
